// Hands auth callback payloads from public routes into the dedicated callback route.
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PageLoader } from '@/ui/PageLoader';
import { shouldHandoffPublicAuthCallback } from '@/modules/auth';

export const PublicAuthCallbackBoundary: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const shouldHandoff = shouldHandoffPublicAuthCallback({
    pathname: location.pathname,
    search: location.search,
    hash: location.hash,
  });

  useEffect(() => {
    if (!shouldHandoff) {
      return;
    }

    navigate(
      {
        pathname: '/auth/callback',
        search: location.search,
        hash: location.hash,
      },
      { replace: true, state: { handoffFrom: location.pathname } },
    );
  }, [location.hash, location.pathname, location.search, navigate, shouldHandoff]);

  if (shouldHandoff) {
    return <PageLoader withLayout={false} />;
  }

  return <>{children}</>;
};

